import styled from "styled-components";
import  Buttons from '../../buttons.jsx';
import AutoSelect from '../autoSelect.jsx';
import { useState,useEffect } from "react";
import { useSelector } from 'react-redux';
import { estadoJuego,newJuego,juegoSelected } from '../../../redux/actions/juegoActions.js';
import { themeModules } from "../../../theme/theme.js";
import SubPanel from "../subPanel.jsx";
import BasicDetailGame from "./basicDetailGame.jsx";
import VideoDetailGame from "./videoDetailGame.jsx";
import DetailGame from "./detailGame.jsx";


const Container=styled.div`
	height:100vh;
	overflow:hidden;
	background-color:${themeModules.background};
	color:white

 `;

const ContainerOptions=styled.div`
	display:flex;
	position:relative;
	justify-content:space-around;	
	align-items:center;
	width:100vw;
	background: rgb(0,0,0);
	background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(38,37,37,1) 35%, rgba(0,0,0,1) 100%);
  `;

const ContainerButtons=styled.div`

 `;

const ContainerEdition=styled.div`
	display:flex;
	position:relative;
	align-items:center;
	justify-content:center;
	height:82%;
	width:100vw;
	@media (max-width: 800px){
			width:100%;
		}
	
 `;
 const ContainerInputs=styled.div`
	display:flex;
	flex-direction:column;
	align-items:center;
	width:100%;
	height:98%;
	min-height:300px;
	justify-content: space-evenly;
		
	box-Shadow:0 10px 20px 5px rgba(0,0,0,0.2); 
	overflow:auto;
	&::-webkit-scrollbar{
		background-color:transparent;
		width:3px
	};
	&::-webkit-scrollbar-track{
		background:trasparent;		
		border-radius:25px
	};
	&::-webkit-scrollbar-thumb {
    	background: #27B0FE;
    	border-radius: 15px;
  	};
  	&::-webkit-scrollbar:horizontal{display:none}
 `;


const ContainerAutoSelect=styled.div`
	width:50vw;
	min-width:450px;
	display:flex;
	justify-content:center;
	border-radius:10px	
 `;


 export default function JuegosAdmin(){

 	let urlBack=process.env.REACT_APP_URL_API;
 
 	let [juegosName,setJuegosName]=useState();
 	let [juegoVacio,setJuegoVacio,]=useState(true);
 	let juegoSelectedRedux=useSelector(state=>state.juego.juegoSelected);
 	let juegos=useSelector(state=>state.juego.juegos);
 	let estado=useSelector(state=>state.juego.estadoJuego);	
	let base={nombre:"",Consolas:[],poster:"",videopresentacion:"",multiplayerOffLine:"",multiplayerOnLine:"",peso:"",audio:"",
					subtitulos:"",descripcion:"",Categoria:[]};
	

 	useEffect(()=>{
 		if(estado===0){
 	 			let nombres=[];
 	 			juegos.map(ele=>ele.activo?nombres.push({label:`${ele.nombre}`,value:ele}):null) 	 	
 	 			setJuegosName(nombres);	
 		}
 	},[urlBack,juegos,estado])


 	useEffect(()=>{
 		juegoSelectedRedux.nombre?setJuegoVacio(false):setJuegoVacio(true);
 	},[juegoSelectedRedux]);
 	

 	return(
 		<Container>
 			<ContainerOptions> 				
 				<ContainerAutoSelect>
 					<AutoSelect data={juegosName}  id="juegos"  label="juegos"  disabled={estado!==0?true:false} action={juegoSelected} />
 				</ContainerAutoSelect>
 				<ContainerButtons >
 					<Buttons
 							estado={estado} 
	 						alterEstado={estadoJuego} 
	 					 	empty={juegoVacio} 
	 					 	action={newJuego} 
	 					 	estadoBase={base} 
	 					 	dataSave={juegoSelectedRedux} 
	 					 	url={`/juego`} 
	 					 	reloadAction={juegoSelected(base)}
	 					 	idDelete={juegoSelectedRedux.id}
	 					 	name={juegoSelectedRedux.nombre} 
	 					 	selected={juegoSelected(base)}
 					/>	
 				</ContainerButtons>
 			</ContainerOptions>


 			<ContainerEdition>
 					<ContainerInputs>
 						<SubPanel child={<BasicDetailGame  value={juegoSelectedRedux} action={newJuego} estado={estado}/ >}/>	
 						<SubPanel child={<VideoDetailGame   value={juegoSelectedRedux} action={newJuego} estado={estado}/ >}/>
 						<SubPanel child={<DetailGame   value={juegoSelectedRedux} action={newJuego} estado={estado}/ >}/>			
 					</ContainerInputs>
 			</ContainerEdition>

 		</Container>


 		)
 }